export const EMPTY_COLUMNS = [
  { childrenIds: [] },
  { childrenIds: [] },
  { childrenIds: [] },
  { childrenIds: [] },
] as const;

export const DEFAULT_4_COLUMNS = [3, 3, 3, 3] as [number, number, number, number];
